import { render, staticRenderFns } from "./dgov2Popup.vue?vue&type=template&id=0e7a03d2&scoped=true&"
import script from "./dgov2Popup.vue?vue&type=script&lang=js&"
export * from "./dgov2Popup.vue?vue&type=script&lang=js&"
import style0 from "./scss/dgov2Popup.scss?vue&type=style&index=0&id=0e7a03d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7a03d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Jenkins\\jobs\\SlideShow\\branches\\release-07-00-09.6uaoor\\workspace\\Scripts\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7a03d2')) {
      api.createRecord('0e7a03d2', component.options)
    } else {
      api.reload('0e7a03d2', component.options)
    }
    module.hot.accept("./dgov2Popup.vue?vue&type=template&id=0e7a03d2&scoped=true&", function () {
      api.rerender('0e7a03d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "dgov2Popup.vue"
export default component.exports